module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Gebenstorf_AG-3b96ed6d4f0fc9da7afd005587fe6a5d.svg";